import { DomainConfigFormValidationSchema, DomainSchemeRedirect, DomainWWWRedirect } from '../../../domains.interfaces';

export const domainConfigFormValidationSchema: DomainConfigFormValidationSchema = {
  isHttps: [{ required: true, type: 'boolean', message: 'Виберіть тип протоколу' }],
  siteId: [{ required: true, type: 'string', message: 'Виберіть сайт' }],
  proxyServerId: [{ required: true, type: 'string', message: 'Виберіть проксі-сервер' }],
  proxyServerAddressId: [{ required: true, type: 'string', message: 'Виберіть адресу проксі-сервера' }],
  dnsRecordId: [{ required: true, type: 'string', message: 'Виберіть DNS запис' }],
  wwwRedirect: [
    { required: true, type: 'string', enum: [DomainWWWRedirect], message: 'Виберіть тип перенаправлення для WWW' }
  ],
  schemeRedirect: [
    {
      required: true,
      type: 'string',
      enum: [Object.values(DomainSchemeRedirect)],
      message: 'Виберіть тип перенаправлення протоколу'
    }
  ],
  staticPrefix: [{ required: false, type: 'string', min: 3, max: 255, message: 'Виберіть префікс статики' }]
};
